/**
 * Created by tmorone on 2/10/2016.
 */

var Marionette = require('backbone.marionette');
var App = require('../app.js');

/**
 * Manages interaction with the Facebook API. When this object is instantiated, it begins the asynchronous load
 * of the Facebook SDK.
 *
 * This module responds to the following global events:
 *      ui:loginFB - calls the FB login method
 *      ui:logout - logs out of FB
 *
 * This module sends the following global events:
 *      fb:statusChange - when the user logs in or logs out
 *      fb:ready - when the Facebook SDK has been loaded
 */
module.exports = Marionette.Object.extend({
    initialize: function() {
        /**
         * Load the Facebook SDK Asynchronously
         */
        (function (d) {
            var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement('script');
            js.id = id;
            js.async = true;
            js.src = "//connect.facebook.net/en_US/all.js";
            ref.parentNode.insertBefore(js, ref);
        }(document));
    }
});

var loginStatusCallback = function(response) {
    if(response.status === 'connected') {
        FB.api('/me', function(user) {
            App.Events.trigger('fb:statusChange', user);
        });
    }
    else  {
        App.Events.trigger('fb:statusChange', {id:null});
    }
};

var shareOnFacebook = function(params) {
    FB.ui( {
        method: 'feed',
        name: params.name,
        description: params.description,
        link: params.url,
        picture: params.image,
        caption: params.caption,
        ref: params.ref
    });
};

/**
 * Called by the Facebook SDK after it loads
 */
window.fbAsyncInit = function () {
    FB.Event.subscribe('auth.statusChange', loginStatusCallback);

    FB.init({
        appId: window.PR.fb_app_id,
        channelUrl: 'http://www.playpackrat.com/portal/channel.html', // Channel File
        status: false, // check login status
        cookie: true, // enable cookies to allow the server to access the session
        xfbml: true  // parse XFBML
    });

    App.Events.trigger("fb:ready");
    App.Events.on("fb:share", shareOnFacebook);
    App.Logger.info("Facebook library loaded");
};

